module.exports = __webpack_public_path__ + "img/img3.87693f6b.svg";